module.exports = __webpack_public_path__ + "img/436-37e136.png";